import globalStore from 'init/global-store'
import { dropCookie, getCookie, setCookie } from 'util/cookie-utils'
import { parseTTdat } from 'util/turnto-utils'

const USER_TOKEN_COOKIE_NAME = 'TT_USER_TOKEN'
const COOKIE_DELIMITER = '|'

function getUserAndToken() {
  const cookieValue = getCookie(USER_TOKEN_COOKIE_NAME)
  if (cookieValue) {
    const cookieParts = cookieValue.split(COOKIE_DELIMITER)
    return { userToken: cookieParts[0], user: parseTTdat(cookieParts[1]).user }
  }
  return { userToken: null, user: null }
}

// to be called when first coming to the page to load logged-in user info if logged-in.
// Can also be used to revalidate.  In other words, log out user if token expired.
function loadLoggedInUser(): void {
  globalStore.user = getUserAndToken().user
}

/**
 * Logs in a user by setting the token in a cookie and sets the user with the passed in user.
 * Also need ttdat, which contains user data. Storing in cookie for the case where the user
 * refreshes or goes to another page.  Can then parse out the user info in "loadLoggedInUser".
 * @param token
 * @param ttdat
 */
function loginUser(token: string, ttdat: string): void {
  globalStore.user = parseTTdat(ttdat).user
  const currentCookieValue = getCookie(USER_TOKEN_COOKIE_NAME)
  const cookieTokenValue = currentCookieValue ? currentCookieValue.split(COOKIE_DELIMITER)[0] : ''
  // only want to set cookie if it doesn't exist or not the same.  Don't want to reset due to
  // expiration period
  if (cookieTokenValue !== token) {
    // setting to expire in 24 hours (86400 seconds)
    setCookie(USER_TOKEN_COOKIE_NAME, `${token}${COOKIE_DELIMITER}${ttdat}`, 86400)
  }
}

// Clears the user data and removes the user token
function logoutUser(): void {
  globalStore.user = null
  dropCookie(USER_TOKEN_COOKIE_NAME)
}

function getUserToken(): string {
  const { user, userToken } = getUserAndToken()
  globalStore.user = user
  return userToken || ''
}

// for some reason when moved to webpack4, no longer could export individually to work in tests.
// it works fine when running the app, just not in tests.  Not ideal, but the whole file is being
// included in the build anyway.
export default { loadLoggedInUser, loginUser, logoutUser, getUserToken }
